document.addEventListener("DOMContentLoaded", function () {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return;

    // change selector if needed
    var $slider = jQuery(".ts-grid");

    // prevent double init
    if ($slider.hasClass("slick-initialized")) return;

    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      arrows: true,
      responsive: [
        { breakpoint: 990, settings: { slidesToShow: 2 } },
        { breakpoint: 640, settings: { slidesToShow: 1, arrows: false } }
      ]
    });
  });



const input = document.getElementById("search-input");
const suggestionsBox = document.getElementById("search-suggestions");

let timeout;

input.addEventListener("keyup", function () {
clearTimeout(timeout);

timeout = setTimeout(() => {
    let query = input.value;

    if (query.length < 2) {
     suggestionsBox.style.display = "none";
     return;
    }

    fetch(`/search/suggest.json?q=${query}&resources[type]=product`)
     .then(res => res.json())
     .then(data => {
        let products = data.resources.results.products;

        if (!products.length) {
         suggestionsBox.innerHTML = "<p style='padding:10px;'>No results</p>";
         suggestionsBox.style.display = "block";
         return;
        }

        let html = "";

        products.forEach(product => {
         html += `
            <a href="${product.url}">
             <img src="${product.image}" alt="${product.title}">
             <span>${product.title}</span>
            </a>
         `;
        });

        suggestionsBox.innerHTML = html;
        suggestionsBox.style.display = "block";
     });
}, 300); // debounce
});

// Hide on outside click
document.addEventListener("click", function (e) {
if (!document.querySelector(".hz-header-top__center").contains(e.target)) {
    suggestionsBox.style.display = "none";
}
});